var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.isMini ? 'in-wx' : 'in-cdn',attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"include":['Home', 'DailyReport']}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }